// Capture the defender. The line's first move takes a piece that was
// guarding another (a fair trade or not), and the line's second move by
// the same side takes the piece it guarded: in the position before the
// line the taken piece defended the square of the one that falls next. The
// variation says what the defender guarded: `piece` here; `mate` (the
// defender of the mating square) is left to the mate detector, which runs
// first and names the mating pattern instead.
import type { Motif } from '@chess/api-mistakes';
import type { TacticLine } from './line.ts';

export function captureDefender(line: TacticLine): Motif | undefined {
  const [first, second, third] = line.pv;
  if (!first || !second || !third) return undefined;
  const defender = line.board.captured(first);
  if (!defender || defender.colour !== line.victim) return undefined;
  const guarded = line.board.attacksFrom(defender.square);
  const afterTwo = line.board.play(first).play(second);
  const prize = afterTwo.captured(third);
  if (!prize || prize.colour !== line.victim || prize.kind === 'pawn' || prize.kind === 'king') return undefined;
  if (!guarded.includes(prize.square)) return undefined;
  return { family: 'captureDefender', variation: 'piece' };
}
